import request from '@/libs/api.request'

// Business permission failures on these routes do not invalidate the login session.
const call = options => request.request({ preserveSessionOnForbidden: true, ...options })
export const productionFactories = params => call({ url: 'factory/list', method: 'get', params })
export const createFabricBatch = (factoryId, data) => call({ url: 'production/fabric-batches', method: 'post', params: { factoryId }, data })
export const listFabrics = params => call({ url: 'production/fabrics', method: 'get', params })
export const fabricDetail = (factoryId, fabricId) => call({ url: `production/fabrics/${encodeURIComponent(fabricId)}`, method: 'get', params: { factoryId } })
export const fabricSegments = (factoryId, fabricId, params) => call({ url: `production/fabrics/${encodeURIComponent(fabricId)}/segments`, method: 'get', params: { ...params, factoryId } })
export const fabricOrderSummary = (factoryId, orderNo) => call({ url: 'production/fabrics/order-summary', method: 'get', params: { factoryId, orderNo } })
export const fabricQr = (factoryId, fabricId) => call({ url: `production/fabrics/${encodeURIComponent(fabricId)}/qr`, method: 'get', params: { factoryId }, responseType: 'blob' })
export const fabricBatchZip = (factoryId, batchId) => call({ url: `production/fabric-batches/${encodeURIComponent(batchId)}/qr.zip`, method: 'get', params: { factoryId }, responseType: 'blob', timeout: 120000 })

export const productionData = response => {
  if (!response || !response.data || response.data.code !== 200) {
    throw new Error((response && response.data && response.data.msg) || '操作失败，请重试')
  }
  return response.data.data
}

export const productionError = error => {
  const body = error && error.response && error.response.data
  return (body && body.msg) || (error && error.message) || '请求失败，请重试'
}

export const newBatchId = () => {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export const fabricBatchPayload = form => {
  const payload = {}
  for (const key of ['orderNo', 'fabricNo', 'fabricType', 'customerName', 'batchNo', 'colorName', 'colorCode', 'composition', 'remark']) {
    const value = String(form[key] || '').trim()
    const max = key === 'remark' ? 1000 : key === 'composition' ? 500 : ['customerName', 'fabricType'].includes(key) ? 200 : 100
    if (value.length > max) throw new Error('填写内容超过允许长度')
    if (value) payload[key] = value
  }
  if (!payload.orderNo || !payload.fabricNo || !payload.fabricType) throw new Error('请填写订单号、布号和布料类型')
  if (!Number.isInteger(form.quantity) || form.quantity < 1 || form.quantity > 500) throw new Error('每次生成数量为 1～500 卷')
  payload.quantity = form.quantity
  for (const key of ['widthCm', 'gramWeightGsm']) {
    if (form[key] !== null && form[key] !== undefined && form[key] !== '') {
      if (!Number.isFinite(form[key]) || form[key] <= 0) throw new Error('门幅和克重必须大于 0，未确定时可留空')
      payload[key] = form[key]
    }
  }
  return payload
}

export const productionBlob = async (response, mime) => {
  const blob = response && response.data
  if (blob instanceof Blob && blob.size && blob.type.split(';')[0] === mime) return blob
  let message = '下载失败，服务器未返回有效文件'
  if (blob instanceof Blob) {
    const text = typeof blob.text === 'function' ? await blob.text() : await new Promise((resolve, reject) => {
      const reader = new window.FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsText(blob)
    })
    try { message = JSON.parse(text).msg || message } catch (_) { /* Not a JSON response. */ }
  } else if (blob && blob.msg) message = blob.msg
  throw new Error(message)
}
